// compiled from:
// https://github.com/hoosin/highlightjs-yara
// https://github.com/ninoseki/highlightjs-yara
// and modified a bit, for better coverage – close to the official VSCode extension

export default function yara(hljs) {
    const ATTRIBUTE = {
        className: 'attr',
        begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
        relevance: 1.01,
    };

    const VARIABLE = {
        className: 'variable',
        match: '(\\$|#|@)[a-zA-Z0-9_*]*',
        relevance: 1.01,
    };

    const PUNCTUATION = {
        match: '/[()]/|/[{}]/|/[[/|/[[]]/|/\\/|/,/',
        className: 'punctuation',
        relevance: 0,
    };

    const NUMBER_YARA = {
        match: /\b[0-9A-Fa-f]{2}\b/g,
        className: 'number',
        relevance: 0,
    };

    const OPERATOR = {
        className: 'operator',
        relevance: 0,
        begin: /[=><&!:+\-*/%^~|]/,
    };

    const RULE_NAME = {
        begin: /\brule\b/,
        className: 'keyword',
        starts: {
            begin: /\s+/,
            end: /(?=\s*[:{])/,
            contains: [
                {
                    className: 'title',
                    begin: /[a-zA-Z_]+/,
                    end: /(?=\s*[:{])/,
                },
            ],
        },
    };

    const reservedKeywords = [
        'true',
        'false',
        'private',
        'global',
        'rule',
        'strings',
        'meta',
        'condition',
        'and',
        'or',
        'none',
        'not',
        'filesize',
        'in',
        'at',
        'of',
        'for',
        'all',
        'any',
        'nocase',
        'fullword',
        'wide',
        'ascii',
        'base64',
        'base64wide',
        'xor',
        'entrypoint',
        'them',
        'int8',
        'int16',
        'int32',
        'int8be',
        'int16be',
        'int32be',
        'uint8',
        'uint16',
        'uint32',
        'uint8be',
        'uint16be',
        'uint32be',
        'include',
        'import',
        'matches',
        'contains',
        'icontains',
        'endswith',
        'iendswith',
        'startswith',
        'istartswith',
        'iequals',
        'defined',
    ];

    const KEYWORDS = {
        className: 'keyword',
        match: new RegExp(`\\b(?:${reservedKeywords.join('|')})\\b`),
        relevance: 0,
    };

    const FIXED_REGEXP = {
        ...hljs.REGEXP_MODE,
        end: /\/[a-z]*/,
    };

    return {
        name: 'YARA',
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            FIXED_REGEXP,
            hljs.QUOTE_STRING_MODE,
            RULE_NAME,
            ATTRIBUTE,
            KEYWORDS,
            VARIABLE,
            PUNCTUATION,
            NUMBER_YARA,
            OPERATOR,
            hljs.C_NUMBER_MODE,
        ],
        illegal: '\\S',
    };
}
